enum ButtonEnum {
  PRIMARY = 'PRIMARY',
  INFO = 'INFO',
  BLANK = 'BLANK',
}

export default ButtonEnum;
